import axios from 'axios'
import AlertModule from 'vux/src/plugins/alert/module'

import store from '../store/index'
const baseUrl = 'http://service.wh.jinxin-fertility.com:8095/api';
/* const baseUrl = 'http://172.18.249.53:8765/api'*/

var instance = axios.create({
baseURL: baseUrl,
timeout: 35000,
headers: {'X-Requested-With': 'XMLHttpRequest'}
})

instance.interceptors.request.use(function (config) {
if (window.localStorage.getItem('token')) {
config.headers.Authorization = window.localStorage.getItem('token')
} else {
AlertModule.show({
title: '提示',
content: '无token！请重新打开当前网页！'
})
}
return config
}, function (error) {
return Promise.reject(error)
})

instance.interceptors.response.use(function (response) {

if (response.status === 200) {
if (response.data.resultCode == 'success') {
if (response.data.data) {
return response.data.data
} else {
return response.data
}
} else {  // 如果resultCode 失败或者 500
store.commit('updateLoadingStatus', {isLoading: false})
AlertModule.show({
title: '提示',
content: response.data.resultMsg
})
return Promise.reject(response.data.resultMsg)
}
} else {   // 如果status 不是200 未通
store.commit('updateLoadingStatus', {isLoading: false})
AlertModule.show({
title: '提示',
content: 'error'
})
}
}, function (error) {
store.commit('updateLoadingStatus', {isLoading: true})
AlertModule.show({
title: '提示',
content: error
})

return Promise.reject(error)
})
export {instance, baseUrl}



// WEBPACK FOOTER //
// ./src/utils/request.js